module.exports = __webpack_public_path__ + "static/media/linkedin.80a1223a.svg";